module.exports = __webpack_public_path__ + "img/radio-tuner.8a4d0434.svg";